<template>
  <el-dialog :visible="show" :title="row ? '编辑作品' : '新增作品'" width="770px" append-to-body @close="closeDialog">
    <el-form label-width="100px" ref="vForm" :model="vForm" size="medium">
      <el-form-item label="排序" prop="sort" :rules="{ required: true, message: '排序必填' }">
        <el-input v-model="vForm.sort"></el-input>
        <div class="v-form-tips">排序值越大越靠前</div>
      </el-form-item>
      <el-form-item label="作品标题" prop="name" :rules="{ required: true, message: '标题必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>

      <template v-if="!row">
        <el-form-item label="拍摄日期" prop="record_time" :rules="{ required: true, message: '拍摄日期必填' }">
          <el-date-picker v-model="vForm.record_time" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%" />
        </el-form-item>
      </template>

      <el-form-item label="所属区域" v-loading="areaLoading" prop="area_id" :rules="{ required: true, message: '关联区域必填' }">
        <el-cascader
          v-model="areaData"
          :options="areaList"
          :props="{ value: 'id', label: 'name', children: 'child' }"
          placeholder="请选择"
          style="width: 100%"
          filterable
          @change="vForm.area_id = areaData[areaData.length - 1]"
        />
      </el-form-item>
      <el-form-item v-if="!row" label="全景图片">
        <vr-upload
          :map="true"
          :loading.sync="doSubmitLoading"
          @success="
            (images) => {
              vForm.keys = images;
            }
          "
        />
        <div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px，拖拽可以进行排序</div>
      </el-form-item>
      <el-form-item label="作品封面">
        <u-image
          width="150"
          height="150"
          v-model="thumb"
          @change="
            (img) => {
              vForm.thumb = img.key;
            }
          "
        ></u-image>
        <div class="v-form-tips">封面尺寸800*800px正方形</div>
        <div class="v-form-tips">不传默认全景默认截图封面</div>
      </el-form-item>
      <el-form-item label="是否推荐" required>
        <el-radio v-model="vForm.is_recommend" :label="2">否</el-radio>
        <el-radio v-model="vForm.is_recommend" :label="1">是</el-radio>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import vrUpload from './vr-upload';

export default {
  props: ['show', 'row'],

  components: { vrUpload },

  data() {
    return {
      doSubmitLoading: false,
      loading: false,
      category: [],
      areaList: [],
      areaLoading: false,
      userLevel: this.$store.getters.userInfo.level,
      vForm: {
        sort: 0,
        works_id: '',
        area_id: '',
        name: '',
        works_category_id: '', //分类id
        material_ids: [], //资源id
        keys: [], //新增图片key name
        thumb: '',
        is_recommend: 2,
        group_name: '',
        record_time: '',
      },
      areaData: [],
      thumb: { key: '', name: '', preview: '' },
    };
  },

  created() {
    this.getCategory();
    this.getArea();
    if (this.row) {
      for (let key in this.row) {
        this.vForm[key] = this.row[key];
      }
      this.vForm.works_id = this.row.id;
      this.vForm.area_id = this.row.area_ids[this.row.area_ids.length - 1];
      this.areaData = this.userLevel == 1 ? this.row.area_ids : [this.row.area_ids[this.row.area_ids.length - 1]];
      this.thumb.key = this.row.thumb || '';
      this.thumb.preview = this.row.thumb_preview || '';
    }
  },

  methods: {
    async getCategory() {
      this.loading = true;
      try {
        let res = await this.api.works.getCategory();
        this.category = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    async getArea() {
      this.areaLoading = true;
      try {
        this.areaList = await this.$store.dispatch('user/getAreaList');
        if (this.userLevel == 3) {
          this.vForm.area_id = this.areaList[0].id;
        }
      } catch (e) {
        console.error(e);
      }
      this.areaLoading = false;
    },

    closeDialog() {
      this.$emit('update:show', false);
    },

    //提交作品
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        let data = JSON.parse(JSON.stringify(this.vForm));
        await this.api.works[this.row ? 'edit' : 'add'](data);
        this.$message.success(!this.row ? '添加成功' : '修改成功');
        this.$emit('success', this.row ? '' : 1);
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped>
.v-form-select {
  position: relative;
}
</style>
